/**
 * Method to determine colour for particular request status
 *
 * @param {string} status ID of status
 * @return {string} Colour to represent status
 */
export default function(status) {
  switch (status) {
    case 'CANCELLED':
      return 'warning';
    case 'REJECTED':
      return 'error';
    case 'APPROVED':
      return 'success';
  }
}
